import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";
import MoreVert from "@material-ui/icons/MoreVert";
import ViewList from "@material-ui/icons/ViewList";

// core components
import AdminNavbarLinks from "./AdminNavbarLinks";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";
import {getCompany} from "../../util/common/Common";

const useStyles = makeStyles(styles);

export default function AdminNavbar(props) {
    const classes = useStyles();
    const {color, rtlActive, brandText} = props;
    const appBarClasses = cx({
        [" " + classes[color]]: color,
    });

    // Ruta de navegacion: Modulo > Menu > Submenu > Pantalla
    function makeBreadcrumb() {
        const href = window.location.href;
        let actual = null;
        props.routes.forEach(prop => {
            const ruta = prop.layout + prop.path;
            if (prop.path !== "/" && href.indexOf(ruta) !== -1
                && (!actual || ruta.length >= (actual.layout + actual.path).length)) {
                actual = prop;
            }
        });
        if (!actual) return [];

        const nombres = [];
        const visitados = new Set();
        let cur = actual;
        while (cur && !visitados.has(cur.codigo)) {
            visitados.add(cur.codigo);
            nombres.unshift(cur.name);
            cur = cur.codigoPadre ? props.routes.find(r => r.codigo === cur.codigoPadre) : null;
        }
        const modulo = props.modulo;
        if (modulo && !nombres.some(n => String(n).toLowerCase() === String(modulo).toLowerCase())) {
            nombres.unshift(modulo);
        }
        return nombres;
    }

    return (
        <AppBar className={classes.appBar + appBarClasses}>
            <Toolbar className={classes.container}>
                <div className={classes.title}>
                    <Hidden smDown implementation="css">
                        <AdminNavbarLinks rtlActive={rtlActive} ruta={makeBreadcrumb()}/>
                    </Hidden>
                </div>
                <Hidden mdUp implementation="css">
                    <Button
                        className={classes.appResponsive}
                        color="transparent"
                        justIcon
                        aria-label="open drawer"
                        onClick={props.handleDrawerToggle}
                    >
                        <Menu/>
                    </Button>
                </Hidden>
            </Toolbar>
        </AppBar>
    );
}

AdminNavbar.propTypes = {
    color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
    rtlActive: PropTypes.bool,
    brandText: PropTypes.string,
    miniActive: PropTypes.bool,
    handleDrawerToggle: PropTypes.func,
    sidebarMinimize: PropTypes.func,
};
